<template>
  <div class="bg-yellow-50 px-5 py-4 rounded">
    <h3 class="flex sm:text-lg font-medium text-gray-900 mb-3 -mt-1">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1 mt-0.5 sm:mt-1 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
      </svg>
      Information on file at the appraisal district
    </h3>

    <dl class="grid grid-cols-1 sm:grid-cols-2 gap-6">
      <!-- Account Number -->
      <div class="sm:col-span-1">
        <dt class="text-sm text-gray-600">Account Number:</dt>
        <dd class="mt-1 text-sm font-medium text-gray-900">
          {{ property.Account_Num }}
        </dd>
      </div>
      <!-- Property Address -->
      <div class="sm:col-span-1">
        <dt class="text-sm text-gray-600">Property Address:</dt>
        <dd class="mt-1 text-sm font-medium text-gray-900">
          {{ property.Situs_Address }}
        </dd>
      </div>

      <!-- Owner Name -->
      <div class="sm:col-span-1">
        <dt class="text-sm text-gray-600">Owner Name:</dt>
        <dd class="mt-1 text-sm font-medium text-gray-900">
          {{ property.Owner_Name }}
        </dd>
      </div>

      <!-- Owner Address -->
      <div class="sm:col-span-1">
        <dt class="text-sm text-gray-600">Mailing Address:</dt>
        <dd class="mt-1 text-sm font-medium text-gray-900">
          {{ ownerFullAddress }}
        </dd>
      </div>

      <div class="sm:col-span-1" v-if="proposedMarketValue && isRegistrationClosedOrFullyOpened">
        <dt class="text-sm text-gray-600">Proposed Market Value {{ REGISTRATION_YEAR }}:</dt>
        <dd class="mt-1 text-lg font-medium" style="color:#a60000">
          {{ proposedMarketValue }}
        </dd>
      </div>

    </dl>
  </div>
</template>
<script>
import { registrationYear } from '../../../../../config/base';

export default {
  props: ["accountNumber", "property", "isRegistrationClosedOrFullyOpened"],
  data() {
      return {
          REGISTRATION_YEAR: registrationYear,
      }
  },
  computed:{
      ownerFullAddress(){
          return (this.property.Owner_Address).trim() + ', ' + (this.property.Owner_CityState).trim() + ', ' + (this.property.Owner_Zip).trim();
      },
      proposedMarketValue(){
        if(this.property && this.property.proposed_market_value){
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0
            });
            return formatter.format(this.property.proposed_market_value);
        }else{
          return null;
        }
      }
  },
  created() {
    console.log("TTTTT", this.isRegistrationClosedOrFullyOpened)
  },
};
</script>
